import css from 'dom-css';

export default class ScrollBarWidth {
  constructor() {
    this.__scrollbarWidth = false;
  }

  get width() {
    if (this.__scrollbarWidth !== false) {
      return this.__scrollbarWidth;
    }

    if (typeof document !== 'undefined') {
      const isMac = navigator.platform.toUpperCase().indexOf('MAC') >= 0;
      const div = document.createElement('div');
      css(div, {
        width: 100,
        height: 100,
        position: 'absolute',
        top: -9999,
        overflow: 'scroll',
        MsOverflowStyle: 'scrollbar',
      });
      document.body.appendChild(div);
      this.__scrollbarWidth = div.offsetWidth - div.clientWidth;
      document.body.removeChild(div);
      if (!this.__scrollbarWidth && isMac) {
        this.__scrollbarWidth = 1;
      }
    } else {
      this.__scrollbarWidth = 0;
    }
    return this.__scrollbarWidth || 0;
  }

  set width(width) {
    this.__scrollbarWidth = width;
  }
}
